import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { UI } from "@wwimmo/ui";
import styles from "./VatProportionHint.module.css";

// #24071: for a VAT code with input-tax share the portal keeps computing the net amount as before, but the ERP
// has the last word. Shown wherever the share is shown (edit row and visa read-only view).
const VatProportionHintBase = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.VatProportionHint}>
            <UI.Icon icon={UI.SVGIcon.InformationFilled} size={16} color="#C26A00" />
            <span>{t("screens.kredi_flow.accountings.vat_proportion_hint")}</span>
        </div>
    );
};

export const VatProportionHint = Sentry.withProfiler(VatProportionHintBase);
